import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/cheeta-logo-orange.png'


const _withScopeId = n => (_pushScopeId("data-v-0702d3e8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "top-banner"
}
const _hoisted_2 = { class: "banner-content" }
const _hoisted_3 = { class: "top-banner-text" }
const _hoisted_4 = { class: "top-banner-button" }
const _hoisted_5 = { class: "banner-actions" }
const _hoisted_6 = { class: "header" }
const _hoisted_7 = ["src"]
const _hoisted_8 = {
  key: 1,
  src: _imports_0,
  alt: "logo"
}
const _hoisted_9 = { class: "nav-bar" }
const _hoisted_10 = { class: "nav-bar-item bordered" }
const _hoisted_11 = ["href"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "navbar-label" }, "FAQs", -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-shopping-cart" }, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "navbar-label" }, "CART", -1))
const _hoisted_16 = [
  _hoisted_14,
  _hoisted_15
]
const _hoisted_17 = {
  key: 0,
  class: "product-title"
}
const _hoisted_18 = { class: "product-name" }
const _hoisted_19 = { class: "company-name" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (_ctx.isBannerVisible && _ctx.companyInfo.announcementBar)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.companyInfo.announcementBar.bannerText), 1),
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_Button, {
                    onClick: _ctx.bannerBtnClick,
                    label: _ctx.companyInfo.announcementBar.btnText,
                    title: _ctx.companyInfo.announcementBar.btnText
                  }, null, 8, ["onClick", "label", "title"])
                ])
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("i", {
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeBanner && _ctx.closeBanner(...args))),
                  class: "pi pi-times",
                  style: {"font-size":"1rem"}
                })
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", {
        class: "logo",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleLogoClick && _ctx.handleLogoClick(...args)))
      }, [
        (_ctx.companyInfo.logo)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: _ctx.companyInfo.logo,
              alt: "logo"
            }, null, 8, _hoisted_7))
          : (_openBlock(), _createElementBlock("img", _hoisted_8))
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("a", {
            href: `${_ctx.baseUrl}/DYO_FAQ.pdf`,
            target: "_blank"
          }, _hoisted_13, 8, _hoisted_11)
        ]),
        _createElementVNode("div", {
          class: "nav-bar-item",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push({ name: 'cart' })))
        }, _hoisted_16)
      ])
    ]),
    (_ctx.getCategoryName)
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
          _createElementVNode("h1", _hoisted_18, _toDisplayString(_ctx.getCategoryName), 1),
          _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.companyInfo.name), 1)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}